import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Dialog,
  DialogContent,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import {
  createShowTemplates,
  editShowTemplates,
  getTemplateData,
  getTemplateList,
} from "../../Services/ExperienceApi";
import { toast, ToastContainer } from "react-toastify";
import { ReactComponent as ArrowbackIcon } from "../../Assets/arrowback.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { ReactComponent as TimeIcon } from "../../Assets/time.svg";
import { ReactComponent as UserIcon } from "../../Assets/cardUser.svg";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as TemplateIcon } from "../../Assets/templates.svg";
import { ReactComponent as SelectTemplateIcon } from "../../Assets/select-template.svg";

const EditShowTemplate = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [loading, setLoading] = useState(false);
  const [saveloading, setSaveLoading] = useState(false);
  const [templates, setTemplates] = useState<any>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingMore, setLoadingMore] = useState(false);
  const [delayBy, setDelayBy] = useState("time");
  const [delayTime, setDelayTime] = useState("");
  const [title, setTitle] = useState("Show Template");
  const [delayTimeError, setDelayTimeError] = useState(false);
  const [idleTimeError, setIdleTimeError] = useState(false);
  const [scrollDepthError, setscrollDepthError] = useState(false);
  const [scrollValue, setScrollValue] = useState("");
  const [selectedTemplateId, setSelectedTemplateId] = useState<number | null>(
    null
  );
  const location = useLocation();
  const fullTemplateId = location.state?.data.id;
  const templateId = fullTemplateId?.split("_")[1];
  const sessionData = sessionStorage.getItem("pendingNodeAddition");
  const sessionObj = sessionData ? JSON.parse(sessionData) : {};
  const experienceId =
    location.state?.data.experinceId || sessionObj.experinceId;
  const fullSegmentId = location.state?.data.segmentId || sessionObj.segmentId;
  const meterValueId =
    location.state?.data.meter_value_id || sessionObj.meterValueId;
  const segmentId = location.state?.data.segmentId
    ? fullSegmentId.split("_")[1]
    : fullSegmentId;
  const navigate = useNavigate();
  const [templateHtml, setTemplateHtml] = useState("");
  const [templateCss, setTemplateCss] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [scrollType, setScrollType] = useState("pixel");
  const [idleTime, setIdleTime] = useState("");
  const [titleError, setTitleError] = useState(false);
  const [displayMode, setDisplayMode] = useState("modal");
  const [elementSelector, setElementSelector] = useState("");
  const [allowModalClose, setAllowModalClose] = useState(false);
  const [showError, setShowError] = useState(false);
  useEffect(() => {
    const fetchExperience = async () => {
      if (segmentId && experienceId && templateId) {
        const response = await getTemplateData(
          experienceId,
          segmentId,
          templateId
        );
        if (response.success === true && response) {
          const templateData = response.experience_template;
          setTitle(templateData.title);
          setSelectedTemplateId(templateData.selected_template_id);
          setDelayBy(templateData.delay_type);
          setAllowModalClose(templateData.allow_close);
          setDisplayMode(templateData.display_type);
          setElementSelector(templateData.inline_container_selector);
          if (
            templateData.delay_type === "scroll_depth_percent" ||
            templateData.delay_type === "scroll_depth_px"
          ) {
            setDelayBy("scroll_depth");
            setScrollType(
              templateData.delay_type.includes("percent") ? "percent" : "pixel"
            );
            setScrollValue(templateData.delay_value?.toString());
          } else {
            setDelayTime(templateData.delay_value?.toString());
            setIdleTime(templateData.delay_value?.toString());
          }
          if (templateData.template) {
            setSelectedTemplate(templateData.template);
            setTemplateHtml(templateData.template.html);
            setTemplateCss(templateData.template.css);
          }
        } else {
          console.log("Error fetching template data");
        }
      }
    };
    fetchExperience();
  }, [segmentId, experienceId, templateId]);
  const fetchTemplates = async (pageNum = 1) => {
    if (loadingMore) return;
    setLoadingMore(true);
    try {
      const response = await getTemplateList(pageNum, 10);
      if (response.success) {
        setTemplates((prev: any) => [...prev, ...response.templates]);
        setTotalPages(response.totalPage || 1);
        setPage(pageNum);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
    setLoadingMore(false);
  };

  useEffect(() => {
    fetchTemplates(page);
  }, [page, rowsPerPage]);

  const filteredTemplates = templates.filter((template: any) =>
    template.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleScroll = (e: any) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;

    if (scrollTop + clientHeight >= scrollHeight - 50) {
      if (page < totalPages && !loadingMore) {
        fetchTemplates(page + 1);
      }
    }
  };

  const handleSave = async () => {
    if (!title.trim()) {
      setTitleError(true);
      return;
    }
    if (!selectedTemplate) {
      setShowError(true);
      return;
    }
    setShowError(false);
    if (delayBy === "time" && !delayTime) {
      setDelayTimeError(true);
      toast.error("Delay By is required");
      return;
    }

    if (delayBy === "idle" && !idleTime) {
      setIdleTimeError(true);
      toast.error("Delay By is required");
      return;
    }

    if (delayBy === "scroll_depth" && !scrollValue) {
      setscrollDepthError(true);
      toast.error("Delay By is required");
      return;
    }

    try {
      setSaveLoading(true);
      const nodeType = sessionStorage.getItem("nodeType");
      const payload = {
        title: title,
        delay_value:
          delayBy === "scroll_depth"
            ? scrollValue
            : delayBy === "idle"
            ? idleTime
            : delayTime,

        delay_type:
          delayBy === "scroll_depth"
            ? `scroll_depth_${scrollType === "percent" ? "percent" : "px"}`
            : delayBy,
        selected_template_id: selectedTemplate.id,
        display_type: displayMode,
        ...(displayMode === "modal" && { allow_close: allowModalClose }),
        ...(displayMode === "inline" && {
          inline_container_selector: elementSelector,
        }),
        ...(nodeType?.toLowerCase() === "paywall" && {
          meter_value_id: meterValueId,
        }),
      };

      let response;
      if (templateId) {
        response = await editShowTemplates(
          experienceId,
          segmentId,
          templateId,
          payload
        );
      } else {
        response = await createShowTemplates(experienceId, segmentId, payload);
      }
      if (response.success === true) {
        toast.success(response.message);
        navigate(-1);
      } else {
        toast.error(response.error);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!");
    } finally {
      setSaveLoading(false);
    }
  };
  const onback = () => {
    navigate(`/edit-experience/${experienceId}`);
  };
  return (
    <div className="templates">
      <Grid container className="templates__header">
        <Grid
          size={{ xs: 12, md: 3, sm: 6 }}
          className="templates__header--search"
        >
          <div className="d-center">
            <span className="Icon">
              <IconButton aria-label="close" onClick={onback}>
                <ArrowbackIcon />
              </IconButton>{" "}
            </span>{" "}
            <h2 className="mb-0"> Show Template</h2>
          </div>
        </Grid>
        <Grid
          size={{ xs: 12, md: 9, sm: 6 }}
          className="templates__header--button "
        >
          <Box className="button-heading">
            <Button
              className="button"
              sx={{
                "--variant-containedBg": "rgba(228, 0, 43, 1)",
                "&:hover": {
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="contained"
              color="error"
              onClick={handleSave}
              disabled={saveloading}
            >
              {saveloading ? <span className="loader" /> : "Save"}
            </Button>
            <Button
              sx={{
                "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                "--variant-containedBg": "rgba(228, 0, 43, 1)",

                "&:hover": {
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="outlined"
              onClick={onback}
            >
              Cancel
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Box className="editSegment__container" mt={2}>
        <Grid container spacing={{ xs: 0, sm: 0, md: 2 }} alignItems={"center"}>
          <Grid size={{ xs: 12, md: 2, sm: 4 }}>
            <div className="editSegment__container--heading">
              <h2>TITLE OF CARD :</h2>
            </div>
          </Grid>
          <Grid
            size={{ xs: 12, md: 8, sm: 8 }}
            className="editSegment__container--heading"
          >
            <TextField
              variant="standard"
              fullWidth
              required
              value={title}
              error={titleError}
              helperText={titleError ? "Title is required" : ""}
              onChange={(e) => {
                const value = e.target.value;
                setTitle(value);
                if (value.trim()) {
                  setTitleError(false);
                }
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Title Input */}

      <Box className="editSegment__container" mt={2} mb={2} p={2}>
        <Grid
          container
          spacing={{ xs: 0, sm: 0, md: 2 }}
          alignItems={"baseline"}
        >
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <Typography variant="body1" fontWeight="bold" mb={1}>
              Select Templates
            </Typography>
            {!selectedTemplate && (
              <Box
                className="select-templates"
                p={2}
                onClick={() => setOpenDialog(true)}
                sx={{
                  border: showError ? "1px solid red" : "1px dashed grey",
                  borderRadius: 1,
                  cursor: "pointer",
                }}
              >
                <>
                  <Box m={2}>
                    <SelectTemplateIcon />
                  </Box>
                  <Typography color="error" fontSize={14} mt={1}>
                    Select a template or a variant
                  </Typography>
                </>
                {showError && (
                  <Typography color="error" variant="caption" mt={0.5}>
                    Template selection is required.
                  </Typography>
                )}
              </Box>
            )}
            <Dialog
              className="modal"
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              fullWidth
              maxWidth="md"
            >
              <h2 className="mb-0">
                {" "}
                <span className="Icon red">
                  <TemplateIcon className="" />{" "}
                </span>{" "}
                Select a Template
              </h2>
              <IconButton
                aria-label="close"
                onClick={() => setOpenDialog(false)}
                sx={(theme) => ({
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>
              <DialogContent
                dividers
                onScroll={handleScroll}
                className="select_template-container"
              >
                <TextField
                  fullWidth
                  label="Search by Title"
                  variant="outlined"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{ mb: 2 }}
                />
                {filteredTemplates.map((template: any) => (
                  <Box
                    className="templates__grid-card"
                    key={template.id}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    flexWrap={"wrap"}
                    mb={2}
                    gap={"10px"}
                  >
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      gap={"20px"}
                      flexWrap={"wrap"}
                    >
                      <img
                        src={
                          template?.html?.match(/src="([^"]+)"/)?.[1] ||
                          "fallback.jpg"
                        }
                        alt={template.title}
                        style={{
                          width: 140,
                          height: 100,
                          objectFit: "cover",
                          borderRadius: 0,
                          border: "1px solid rgba(223, 223, 223, 1)",
                        }}
                      />
                      <Box className="templates__grid-info" mt={0}>
                        <h3>{template.title}</h3>
                        <div>
                          <p>
                            <span>
                              <UserIcon />
                            </span>{" "}
                            {template.updated_by}
                          </p>
                        </div>
                        <p>
                          <span>
                            <TimeIcon />
                          </span>{" "}
                          {template.updatedAt}
                        </p>
                      </Box>
                    </Box>

                    <Box>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setSelectedTemplate(template);
                          setOpenDialog(false);
                        }}
                        sx={{
                          background: "rgb(228, 0, 43)",
                        }}
                      >
                        Select
                      </Button>
                    </Box>
                  </Box>
                ))}
                {loadingMore && <CircularProgress />}
              </DialogContent>
            </Dialog>

            {selectedTemplate && (
              <Box
                sx={{
                  border: "1px solid rgba(223, 223, 223, 1)",
                  boxShadow: "0px 4px 60px 0px rgba(0, 0, 0, 0.07)",
                  padding: "1rem",
                }}
                key={selectedTemplate.id}
              >
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  className="templates__grid-card"
                  mb={2}
                  gap={"20px"}
                  flexWrap={"wrap"}
                >
                  <img
                    src={
                      selectedTemplate?.html?.match(/src="([^"]+)"/)?.[1] ||
                      "fallback.jpg"
                    }
                    alt={selectedTemplate?.title}
                    style={{
                      width: 140,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: 0,
                      border: "1px solid rgba(223, 223, 223, 1)",
                    }}
                  />
                  <Box className="templates__grid-info" mt={0}>
                    <h3>{selectedTemplate.title}</h3>
                    <div>
                      <p>
                        <span>
                          <UserIcon />
                        </span>{" "}
                        {selectedTemplate.updated_by}
                      </p>
                    </div>
                    <p>
                      <span>
                        <TimeIcon />
                      </span>{" "}
                      {selectedTemplate.updatedAt}
                    </p>
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  sx={{
                    mt: 1,
                    background: "rgb(228, 0, 43)",
                    cursor: "pointer",
                    mb: 1,
                  }}
                  onClick={() => setOpenDialog(true)}
                >
                  Select a template or a variant
                </Button>
              </Box>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            {/* Suggested Templates */}
            <Box flex={1} mt={4} className="templates__grid">
              <Typography variant="body1" fontWeight="bold" mb={1}>
                Suggested Templates
              </Typography>
              {templates.length === 0 && !loading && (
                <Typography color="textSecondary">
                  No templates found
                </Typography>
              )}
              {templates.slice(0, 2).map((template: any) => (
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  className="templates__grid-card"
                  flexWrap={"wrap"}
                  mb={2}
                  gap={"20px"}
                  key={template.id}
                >
                  <img
                    src={
                      template?.html?.match(/src="([^"]+)"/)?.[1] ||
                      "fallback.jpg"
                    }
                    style={{
                      width: 140,
                      height: 100,
                      objectFit: "cover",
                      borderRadius: 0,
                      border: "1px solid rgba(223, 223, 223, 1)",
                    }}
                  />
                  <Box className="templates__grid-info" mt={0}>
                    <h3>{template.title}</h3>
                    <div>
                      <p>
                        <span>
                          <UserIcon />
                        </span>{" "}
                        {template.updated_by}
                      </p>
                    </div>
                    <p>
                      <span>
                        <TimeIcon />
                      </span>{" "}
                      {template.updatedAt}
                    </p>
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>

        <Box className="editSegment__container" p={2}>
          <h4>DISPLAY MODE</h4>
          <Grid container mt={2}>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Box border="1px solid rgba(212, 212, 212, 1)">
                <Box className="editSegment__container--innerheading ">
                  <h2>TYPE</h2>
                  <FormControl
                    sx={{ marginTop: "1rem", width: "100%" }}
                    size="small"
                  >
                    <Select
                      labelId="demo-simple-select-helper-label"
                      variant="outlined"
                      fullWidth
                      value={displayMode}
                      onChange={(e) => setDisplayMode(e.target.value)}
                    >
                      <MenuItem value="inline">Inline on page</MenuItem>
                      <MenuItem value="modal">Modal/Lightbox</MenuItem>
                    </Select>
                  </FormControl>
                  {displayMode === "modal" && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={allowModalClose}
                          onChange={(e) => setAllowModalClose(e.target.checked)}
                        />
                      }
                      label="Allow user to close modal"
                    />
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Box border="1px solid rgba(212, 212, 212, 1)">
                <Box className="editSegment__container--innerheading " mb={2}>
                  <h2>SELECTOR FOR INLINE CONTAINER</h2>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder="Class or ID of an element on the page(.class, #elements)"
                    value={elementSelector}
                    onChange={(e) => setElementSelector(e.target.value)}
                    disabled={displayMode === "modal"}
                    className={displayMode === "modal" ? "greyed-out" : ""}
                    sx={{ marginTop: "16px" }}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Box border="1px solid rgba(212, 212, 212, 1)">
                <Box className="editSegment__container--innerheading ">
                  <h2>DELAY BY</h2>
                  <Grid container spacing={2} mt={2}>
                    <Grid size={{ xs: 12, md: 3, sm: 6 }}>
                      <FormControl sx={{ width: "100%" }} size="small">
                        <Select
                          labelId="demo-simple-select-helper-label"
                          variant="outlined"
                          fullWidth
                          value={delayBy}
                          onChange={(e) => setDelayBy(e.target.value)}
                        >
                          <MenuItem value="scroll_depth">Scroll Depth</MenuItem>
                          <MenuItem value="time">Time</MenuItem>
                          <MenuItem value="idle">Idle</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 9, sm: 6 }}>
                      <Grid
                        container
                        spacing={2}
                        alignItems={"center"}
                        flexWrap={"wrap"}
                      >
                        {delayBy === "scroll_depth" && (
                          <Grid
                            size={{ xs: 12, md: 6, sm: 6 }}
                            spacing={1}
                            width="100%"
                            display={"flex"}
                            justifyContent={"space-between"}
                            gap={2}
                          >
                            <FormControl fullWidth size="small">
                              <InputLabel id="scroll-type-label">
                                Scroll Type
                              </InputLabel>
                              <Select
                                labelId="scroll-type-label"
                                label="Scroll Type"
                                value={scrollType}
                                onChange={(e) => setScrollType(e.target.value)}
                              >
                                <MenuItem value="pixel">Pixel</MenuItem>
                                <MenuItem value="percent">Percent</MenuItem>
                              </Select>
                            </FormControl>

                            <TextField
                              size="small"
                              fullWidth
                              label={
                                scrollType === "percent"
                                  ? "Scroll Percent"
                                  : "Scroll Pixels"
                              }
                              value={scrollValue}
                              error={scrollDepthError}
                              helperText={
                                scrollDepthError
                                  ? "Scroll Value is required"
                                  : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                setScrollValue(value);
                                setscrollDepthError(false);
                              }}
                              onBlur={() => {
                                if (!scrollValue) {
                                  setscrollDepthError(true);
                                }
                              }}
                            />
                          </Grid>
                        )}

                        {delayBy === "time" && (
                          <Grid
                            size={{ xs: 12, md: 6, sm: 6 }}
                            spacing={1}
                            width="100%"
                          >
                            <TextField
                              size="small"
                              fullWidth
                              label="Time (Sec)"
                              value={delayTime}
                              error={delayTimeError}
                              helperText={
                                delayTimeError ? "Time is required" : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                setDelayTime(value);
                                setDelayTimeError(false);
                              }}
                              onBlur={() => {
                                if (!delayTime) {
                                  setDelayTimeError(true);
                                }
                              }}
                            />
                          </Grid>
                        )}

                        {delayBy === "idle" && (
                          <Grid
                            size={{ xs: 12, md: 4, sm: 6 }}
                            spacing={1}
                            width="100%"
                          >
                            <TextField
                              size="small"
                              fullWidth
                              label="Idle (Sec)"
                              value={idleTime}
                              error={idleTimeError}
                              helperText={
                                idleTimeError ? "Idle is required" : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, "");
                                setIdleTime(value);
                                setIdleTimeError(false);
                              }}
                              onBlur={() => {
                                if (!idleTime) {
                                  setIdleTimeError(true);
                                }
                              }}
                            />
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <ToastContainer position="top-right" autoClose={3000} />
      </Box>
    </div>
  );
};

export default EditShowTemplate;
